import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Header from "../components/header";
import Footer from "../components/footer";
import { Helmet } from "react-helmet-async";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

const ContactUs = () => {

    const { executeRecaptcha } = useGoogleReCaptcha();

    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [responseMsg, setResponseMsg] = useState("");
    const [contactInfo, setContactInfo] = useState({});
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        category: "",
        message: ""
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!executeRecaptcha) {
            setResponseMsg("Captcha not ready");
            return;
        }

        try {

            const token = await executeRecaptcha("contact_form");

            const res = await axios.post(
                "https://kskrishnasilver.com/api/add_inquiry.php",
                {
                    ...formData,
                    recaptchaToken: token
                },
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            );

            setResponseMsg(res.data.message);

            setFormData({
                name: "",
                email: "",
                phone: "",
                category: "",
                message: ""
            });

        } catch (err) {
            setResponseMsg("Something went wrong");
        }
    };

    // Preloader timer
    useEffect(() => {
        const timer = setTimeout(() => setLoading(false), 1000);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        axios
            .get("https://kskrishnasilver.com/api/category.php")
            .then((res) => {
                if (Array.isArray(res.data)) {
                    setCategories(res.data);
                } else if (res.data.data) {
                    setCategories(res.data.data);
                }
            })
            .catch((err) => console.error(err));
    }, []);

    useEffect(() => {

        axios
            .get("https://kskrishnasilver.com/api/contact.php")
            .then((res) => {
                setContactInfo(res.data);
            })
            .catch((err) => console.log(err));

    }, []);

    return (
        <>
            {loading && (
                <div className="loader-wrapper">
                    <div className="ring-loader"></div>
                </div>
            )}
            <Header />
            <Helmet>
                <title>
                    {`Contact Us | Krishna Silver | ${process.env.REACT_APP_PHONE}`}
                </title>
            </Helmet>

            <div className="collection-page">
                <div className="collection-hero">
                    <h1><Link to="/">Home</Link> <span> ~ </span> <Link className="activepage" to="/contact-us">Contact Us</Link></h1>
                </div>
            </div>

            <section className="contact-section">
                <div className="container">
                    <div className="contact-container">

                        {/* LEFT PANEL */}
                        <div className="contact-left">

                            <h2>Contact Details</h2>

                            <p>
                                Connect with India's leading silver jewelry manufacturer for premium
                                bulk requirements and custom branding.
                            </p>

                            <div className="contact-info">

                                <div className="info-item">
                                    <i className="fa-solid fa-phone"></i>
                                    <div>
                                        <span>CALL</span>
                                        <p><Link to={`tel:+91${contactInfo.mobile}`}> +91 {contactInfo.mobile} </Link></p>
                                    </div>
                                </div>

                                <div className="info-item">
                                    <i className="fa-solid fa-envelope"></i>
                                    <div>
                                        <span>EMAIL ADDRESS</span>
                                        <p><Link to={`mailto:${contactInfo.email}`}> {contactInfo.email} </Link></p>
                                    </div>
                                </div>

                                <div className="info-item">
                                    <i className="fa-solid fa-location-dot"></i>
                                    <div>
                                        <span>ADDRESS</span>
                                        <p><Link to={contactInfo.map_link} target="_blank"> {contactInfo.address} </Link></p>
                                    </div>
                                </div>

                                <div className="info-item">
                                    <i className="fa-solid fa-clock"></i>
                                    <div>
                                        <span>WORKING HOURS</span>
                                        <p>{contactInfo.working_hours}</p>
                                    </div>
                                </div>

                            </div>


                        </div>

                        {/* RIGHT PANEL */}
                        <div className="contact-right">

                            <h3>Keep In Touch With Us</h3>

                            <form className="inquiry-form" onSubmit={handleSubmit}>

                                <input
                                    type="text"
                                    name="name"
                                    placeholder="YOUR NAME"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                />

                                <input
                                    type="email"
                                    name="email"
                                    placeholder="EMAIL ADDRESS"
                                    value={formData.email}
                                    onChange={handleChange}
                                />

                                <input
                                    type="text"
                                    name="phone"
                                    placeholder="PHONE NUMBER"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    required
                                />

                                <select
                                    name="category"
                                    value={formData.category}
                                    onChange={handleChange}
                                >
                                    <option value="">SELECT</option>
                                    {categories.map((cat, index) => (
                                        <option key={index} value={cat.name}>
                                            {cat.name}
                                        </option>
                                    ))}
                                </select>

                                <textarea
                                    name="message"
                                    rows="4"
                                    placeholder="ENTER YOUR MESSAGE"
                                    value={formData.message}
                                    onChange={handleChange}
                                />

                                <button type="submit">SUBMIT INQUIRY</button>
                                {responseMsg && (
                                    <p style={{ color: "green" }}>
                                        {responseMsg}
                                    </p>
                                )}
                            </form>

                        </div>

                    </div>
                </div>
            </section>


            <section className="map-section">

                <iframe
                    title="Krishna Silver Location"
                    src={contactInfo.map_embed}
                    width="100%"
                    height="450"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                ></iframe>

            </section>

            <Footer />
        </>
    );
};

export default ContactUs;